import { NoResults } from "../../../../../components/NoResults/NoResults.js";
import { useRPCContext } from "../../../../../contexts/RPCContext.js";
import { getSystemInfoTarget, metadataLastSawDatePropName } from "../../constants.js";
import { Post } from "../../components/Post.js";
import { usePaginationState } from "../../../../../hooks/usePaginationState/index.js";
import { useSystemInfoForTarget } from "../../hooks/useSystemInfoForTarget.js";
import { useAppList } from "../../../../AppWrapper2/hooks/useAppList.js";
import { SystemInfosList } from "../../components/SystemInfosList/index.js";
import { useEffect, useState } from "react";
import { Loading, Modal, Pagination } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdCampaign } from "react-icons/md";
// src/modules/SystemInfo/shared/screens/SystemInfoSidebarScreen/index.tsx
function SystemInfoSidebarScreen() {
	const { rpcService } = useRPCContext();
	const { currentAppId } = useAppList();
	const targetApp = getSystemInfoTarget(currentAppId);
	const [selectedSystemInfo, setSelectedSystemInfo] = useState();
	const { recordsPerPage, setSkippedRecords, skippedRecords } = usePaginationState(`systemInfos_${targetApp}`, { defaultRecordsPerPage: 25 }, []);
	const { data, loading } = useSystemInfoForTarget(targetApp && {
		pagination: {
			limit: recordsPerPage,
			skip: skippedRecords
		},
		target: targetApp
	});
	useEffect(() => {
		return () => {
			try {
				rpcService.Auth.SaveUserClientMetadataWebData.v1.call({ webClientData: { [metadataLastSawDatePropName]: (/* @__PURE__ */ new Date()).toISOString() } });
			} catch (err) {
				console.log("updateSystemInfoLastSawDate() err", err);
			}
		};
	}, []);
	if (loading || !data) return /* @__PURE__ */ jsx("div", {
		className: "mt-xxl flex justify-center",
		children: /* @__PURE__ */ jsx(Loading, {
			message: "Loading",
			messagePosition: "vertical"
		})
	});
	if (!data.systemInfos.length) return /* @__PURE__ */ jsx(NoResults, {
		iconName: MdCampaign,
		text: "There are no announcements yet"
	});
	return /* @__PURE__ */ jsxs("div", { children: [
		/* @__PURE__ */ jsx(SystemInfosList, {
			onItemClick: setSelectedSystemInfo,
			systemInfos: data.systemInfos
		}),
		/* @__PURE__ */ jsx("div", {
			className: "bg-surface-subtle p-sm sticky bottom-0",
			children: /* @__PURE__ */ jsx(Pagination, {
				onPageClick: setSkippedRecords,
				recordsPerPage,
				skippedRecords,
				totalRecords: data.total
			})
		}),
		!!selectedSystemInfo && /* @__PURE__ */ jsx(Modal, {
			closeHandler: () => setSelectedSystemInfo(void 0),
			escPressClose: true,
			outsideClickClose: true,
			children: /* @__PURE__ */ jsx(Post, {
				body: selectedSystemInfo.body,
				bodyHtml: selectedSystemInfo.bodyHtml,
				excerpt: selectedSystemInfo.excerpt,
				timestamp: selectedSystemInfo.publishDate,
				title: selectedSystemInfo.title,
				type: selectedSystemInfo.type
			})
		})
	] });
}
export { SystemInfoSidebarScreen };

//# sourceMappingURL=index.js.map